export * from './appointment-light-new.component';
